<div id="container">
  <div class="container card shadow-sm p-3">
    <div id="header" class="form-group position-relative">
      <div>
        <div class="d-flex align-items-center justify-content-between">
          <label for="filter">{{ label() }}</label>
          <div>
            @if(saveButton()){
            <button class="btn btn-sm btn-outline-primary" [disabled]="!selectedTagsChanged()" (click)="onSaveClick()">{{saveLabel()}}</button>
            }
            <p
              class="btn"
              (click)="toggleCollapse()"
              [title]="toggleCollapseStatus() ? 'Expand all genres' : 'Collapse all genres'"
            >
              <em
                class="bi"
                [ngClass]="{
                  'bi-chevron-expand': toggleCollapseStatus(),
                  'bi-chevron-contract': !toggleCollapseStatus()
                }"
              ></em>
            </p>
            <p class="btn" (click)="resetFilters()" title="Reset filter">
              <em class="bi bi-trash"></em>
            </p>
          </div>
        </div>
        <hr class="row justify-content-center" />
      </div>
      @if (!hideSearch()) {
      <div class="search-container">
        <em class="bi bi-search"></em>
        <input
          type="text"
          [(ngModel)]="search"
          name="filter"
          id="filter"
          placeholder="Search"
        />
      </div>
      }
    </div>
    <hr />
    <div class="genre">
      <app-collapsible buttonLabel="Current selected tags">
        @if (getSelectedEcosystems().length) {
        <div class="d-flex w-100 flex-wrap gap-1">
          @for (ecosystem of getSelectedEcosystems(); track ecosystem.id) {
          <app-tag
            [isSelected]="ecosystem.selected!"
            [name]="ecosystem.name"
            [backgroundColor]="ecosystem.backgroundColor!"
            [textColor]="ecosystem.textColor!"
            (click)="toggleEcosystem(ecosystem)"
          >
          </app-tag>
          }
        </div>
        @if (getSelectedEcosystems().length) {
        <hr class="w-50" />
        } }
        <div class="d-flex w-100 flex-wrap gap-1">
          @for (tag of getSelectedTags(); track tag.id) {
          <app-tag
            [isSelected]="tag.selected!"
            [name]="tag.name"
            [backgroundColor]="tag.tagGenre?.backgroundColor!"
            [textColor]="tag.tagGenre?.textColor!"
            (click)="toggleTag(tag)"
          >
          </app-tag>
          }
        </div>
      </app-collapsible>
      <hr />
    </div>
    <div class="genre">
      <app-collapsible buttonLabel="Ecosystem">
        @if (!hideExclude()){
        <button excludeButton [ngClass]="'btn btn-sm btn-' + excludeEcosystemButtonStyle()"  (click)="techsStore.toggleEcosystemExclude()">!</button>
        }
        <div class="d-flex w-100 flex-wrap gap-1">
          @for (ecosystem of getSortedEcosystems(); track ecosystem.id) {
            <app-tag
              [isSelected]="ecosystem.selected!"
              [name]="ecosystem.name"
              [backgroundColor]="ecosystem.backgroundColor!"
              [textColor]="ecosystem.textColor!"
              (click)="toggleEcosystem(ecosystem)"
            >
            </app-tag>
          }
        </div>
      </app-collapsible>
      <hr />
    </div>
    @for (genre of allGenres(); track genre.id) {
    <div class="tag-genre-box">
      @if (filterTagByGenre(genre.id)?.length) {
      <app-collapsible buttonLabel="{{ genre.name }}">
        @if (!hideExclude()){
            <button excludeButton  [ngClass]="'btn btn-sm btn-' + excludeGenreButtonStyle(genre.id!)"  (click)="techsStore.toggleGenreExclude(genre.id!)">!</button>
        }
        <div class="d-flex w-100 flex-wrap gap-1">
          @for (tag of filterTagByGenre(genre.id); track tag.id) {
          <app-tag
            [isSelected]="tag.selected!"
            [name]="tag.name"
            [backgroundColor]="tag.tagGenre?.backgroundColor!"
            [textColor]="tag.tagGenre?.textColor!"
            (click)="toggleTag(tag)"
          >
          </app-tag>
          }
        </div>
      </app-collapsible>
      <hr />
      }
    </div>
    } @if ((filterTagWithoutGenre())?.length) {
    <div class="genre">
      <app-collapsible buttonLabel="Tags without genres">
        @if (!hideExclude()){
        <button excludeButton  [ngClass]="'btn btn-sm btn-' + excludeGenreButtonStyle('')"  (click)="techsStore.toggleGenreExclude('')">!</button>
        }
        <div class="d-flex w-100 flex-wrap gap-1">
          @for (tag of filterTagWithoutGenre(); track tag.id) {
          <app-tag
            [isSelected]="tag.selected!"
            [name]="tag.name"
            [backgroundColor]="tag.tagGenre?.backgroundColor!"
            [textColor]="tag.tagGenre?.textColor!"
            (click)="toggleTag(tag)"
          >
          </app-tag>
          }
        </div>
      </app-collapsible>
      <hr />
    </div>
    }
  </div>
</div>
